// legacy file
import { useConfig, useGate } from "statsig-react";

// eslint-disable-next-line no-restricted-imports
import { useSelector } from "react-redux";

import config from "#config";
import { getActiveStore } from "src/redux/selectors";

export const useMultiMenusEnabled = () =>
    useGate(config.featureGates.multiMenus).value;

export const useCustomHoursEnabled = () =>
    useGate(config.featureGates.customHours).value;

export const useReportsPayoutEnabled = () =>
    useGate(config.featureGates.rdbReportsHidePayout).value;

export const useMultiStoreSalesSummary = () =>
    useGate(config.featureGates.multistoreSalesSummaryReport).value;

export const useBlacklistedPhoneKioskRewardsFieldEnabled = () =>
    useGate(config.featureGates.blacklistedPhoneKioskRewards).value;

export const useReportsLaborTiles = () =>
    useGate(config.featureGates.reportsLaborTiles).value;

export const useSelfServePromoCodeEnabled = () =>
    useGate(config.featureGates.selfServePromoCodeEnabled).value;
export const useCateringEnabled = () => {
    const store = useSelector(getActiveStore);
    return store?.cateringEnabled;
};

export const useSnackTvSettingsEnabled = () =>
    useGate(config.featureGates.snackTvSettings).value;

export const useGiftCardReportsEnabled = () =>
    useGate(config.featureGates.reportsGiftCard).value;


export const useSelfServeTaxRateEnabled = () =>
    useGate(config.featureGates.selfServeTaxRate).value;

export const useStripeHostedPayoutsOnboardingEnabled = () =>
    useGate(config.featureGates.stripeHostedPayoutsOnboarding).value;

export const useTaxFormsEnabled = () =>
    useConfig("2023_1099k_status").config.get<
        "not_applicable" | "no_w9" | "ineligible" | "eligible"
    >("status", "not_applicable") !== "not_applicable";

export const useInvoicesEnabled = () =>
    useGate(config.featureGates.invoices).value;

export const usePrepStationsEnabled = () =>
    useGate(config.featureGates.prepStations).value;

export const useMenusEnabled = () =>
    useGate(config.featureGates.menusEnabled).value;

export const useMultipleActiveMenusEnabled = () =>
    useGate(config.featureGates.multipleActiveMenus).value;

export const usePrepStationsChannelFulfillmentEnabled = () =>
    useGate(config.featureGates.prepStationChannelFulfillment).value;

export const useEnableKeyBasedRegistration = () =>
    useGate(config.featureGates.enableKeyBasedRegistration).value ||
    !!(
        process.env.REACT_APP_STATSIG_OVERRIDES &&
        /\+enable_key_based_registration\s*($|,)/.test(
            process.env.REACT_APP_STATSIG_OVERRIDES,
        )
    );

export const useReusableGenericPromotionFormEnabled = () =>
    useGate(config.featureGates.reusableGenericPromotionForm).value;

export const useDeliveryFeeSettingsEnabled = () =>
    useGate(config.featureGates.deliveryFeeSettings).value;

export const useLookbookEditorEnabled = () =>
    useGate(config.featureGates.lookbookEditor).value;

export const useIsNewStackEnabled = () =>
    useGate(config.featureGates.newStack).value;

export const useIsGCImportsEnabled = () =>
    useGate(config.featureGates.giftCardImports).value;
